import React, { useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Import the styles
import styles from '../theme/styles';

// Import contexts and hooks
import WindowDimensions from '../common/fn/WindowDimensions';
import useFixedActionBarReserve from '../hooks/useFixedActionBarReserve';

// Import Views
import HeaderV2 from '../component/Header/HeaderV2';
import Footer from '../component/Footer';

const ThemeWrapper = (props) => {
  const { backButtonFn, shouldShowBackButton, classes, children } = props;
  const { IS_MOBILE_HEIGHT } = WindowDimensions();
  const mainRef = useRef(null);
  // Reserve footer space above any fixed action bar (see event.js).
  useFixedActionBarReserve(mainRef, IS_MOBILE_HEIGHT);

  // Under HashRouter the bare #maincontent hash would route to /maincontent and remount the screen.
  const skipToMain = (event) => {
    event.preventDefault();
    mainRef.current?.focus();
  };

  return (
    <React.Fragment>
      <div className={classes.skipContent}>
        <a href="#maincontent" onClick={skipToMain}>Skip to Main Content</a>
      </div>
      <HeaderV2
        shouldShowBackButton={shouldShowBackButton}
        backButtonFn={() => {
          backButtonFn();
        }}
      />
      <main
        ref={mainRef}
        role="main"
        id="maincontent"
        tabIndex={-1}
        className={classNames(
          { is_mobile_height: IS_MOBILE_HEIGHT },
          classes.mainContainer,
          classes.mainContainerFocusTarget,
        )}
      >
        <div className={classes.pageContentContainer}>
          {children}
        </div>
      </main>
      <Footer />
    </React.Fragment>
  );
};

ThemeWrapper.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  backButtonFn: PropTypes.func,
};

export default withStyles(styles)(ThemeWrapper);
